export const experience = [
  {
    id: 'aps-pacific',
    period: '2025 — Present',
    periodShort: '2025—Now',
    role: 'Software Dev Engineer II',
    team: 'Amazon Ads · Publisher Services',
    location: 'Austin, TX',
    accent: 'now',
    current: true,
    highlights: [
      'Owned end-to-end delivery of a programmatic deal-management product — wrote the majority of the deal-negotiation API and authored the API template that became the team\'s reference standard.',
      'Stabilized publisher-planning oncall by designing OpenSearch sharding logic and a cluster-sizing model derived from planning-data characteristics — eliminated throttling caused by memory pressure.',
      'Designed and implemented bid-stream package-scaling end-to-end (UI · API · data orchestration); design doc benchmarked 5 architectural approaches on performance and latency before selecting the optimal.',
      'Diagnosed a cross-system regression where an internal revenue metric exceeded 100% — root-caused via catalog-deployment knowledge and provided architectural guidance for EU market expansion.',
      'Completed JDK 17 migration for the team\'s data-lake ETL service; built control-plane widgets and segments allow-list capability.',
      'Mentoring junior engineers on data pipelines and product operations; raising the team\'s code-quality bar through design-doc reviews.',
    ],
    tech: ['Java', 'TypeScript', 'AWS CDK', 'OpenSearch', 'Lambda', 'DynamoDB', 'React', 'Lake Formation'],
  },
  {
    id: 'aps-pmp',
    period: '2022 — 2025',
    periodShort: '2022—2025',
    role: 'SDE I → SDE II',
    team: 'Amazon Ads · Publisher Reporting',
    location: 'Austin, TX',
    accent: 'pmp',
    promotion: true,
    promotionYear: 2024,
    promotionLabel: 'Promoted · Exceeds High Bar',
    highlights: [
      'Reduced infrastructure vulnerabilities from 200+ exposed instances to 1–2 at any time by adopting auto-patching and migrating Airflow stack from ECS to MWAA with tuned cluster configuration.',
      'Cut hourly Glue / Step-Functions / Lambda job runtime from over 60 minutes to under 15 minutes for advertiser-group ingestion — replacing the legacy EMR + Airflow approach.',
      'Delivered a unified deal-management feature in 4 weeks end-to-end (UI · portal reporting · sync Lambda) under aggressive timeline.',
      'Migrated programmatic-guaranteed creative-preview from Java to TypeScript, building API clients across 3 partner systems and a new async-loading React component.',
      'Architected AWS Lake Formation–based catalog unification (data lake + clean rooms) to optimize query performance and migrate bid-stream publishers off legacy storage.',
      'Migrated publisher-reporting Airflow stack from v1 → v2; introduced Deal Earnings to its own DAG, improving report latency for publishers.',
      'Recognition-pipeline fix secured $500K in incremental spend commitment from two top-10 beauty advertisers (sales-team-led).',
      'Authored 3 Operational Readiness Reviews; subject-matter expert on data pipelines and AWS CDK.',
    ],
    tech: ['MWAA', 'EMR Serverless', 'Glue', 'Step Functions', 'Lambda', 'Redshift', 'Java', 'TypeScript', 'Scala', 'Ruby on Rails', 'HAML', 'React'],
  },
  {
    id: 'flawless-invoice',
    period: 'Sept 2021 — May 2022',
    periodShort: '2021—2022',
    role: 'Software Dev Engineer I',
    team: 'Amazon B2B Payments · Flawless Invoice',
    location: 'Seattle, WA',
    accent: 'flawless',
    highlights: [
      'Built and operated invoice-validation services that gate enterprise outbound invoices in Amazon B2B Payments.',
      'Ramped on AWS CDK and LPT pipelines for Java Lambda services from zero prior exposure; closed Operational-Excellence backlog spanning AWS services new to the team.',
    ],
    tech: ['AWS CDK', 'Java', 'Lambda', 'LPT'],
  },
];
